import { IsAdminActionType, IReceiveIsAdminAction, IRequestIsAdminAction } from './IsAdmin.action-types';

export function requestIsAdmin(): IRequestIsAdminAction {
    return {
        type: IsAdminActionType.REQUEST_IS_ADMIN,
    };
}

export function receiveIsAdmin(isAdmin: boolean): IReceiveIsAdminAction {
    return {
        type: IsAdminActionType.RECEIVE_IS_ADMIN,
        isAdmin,
    };
}
